import { API_ROOT } from '../../config/config'
import { doGet, doPost, doDownload, doPostFiles, doDelete, doPut, doPutFiles } from './utils'

const API_ROOT_VER = `${API_ROOT}/v1/accounting`

export const getAssetBackEdit = (pageNumber, pageSize) => {
  const url = `${API_ROOT_VER}/asset-back-edit?pageNumber=${pageNumber || 0}&pageSize=${
    pageSize || 0
  }`

  return doGet(url)
}

export const searchAssetBackEdit = (request, pageNumber, pageSize) => {
  // ​/api​/v1​/accounting​/asset-back-edit​/search
  const url = `${API_ROOT_VER}/asset-back-edit/search?pageNumber=${pageNumber || 0}&pageSize=${
    pageSize || 0
  }`

  return doPost(url, request)
}
